export enum ALIEO_TYPE {
  ASSET,
  LIABILITY,
  INCOME,
  EXPENSE,
}

export const DEFAULT_VALUE = '--';
